import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';

const MaterialClearIcon = () => {
  return <ClearOutlinedIcon htmlColor="#1A1A1A75" />;
};

export default MaterialClearIcon;
